/**
 * Formats a signed amount as an absolute currency value plus its direction.
 * Positive is a refund to the client, negative is owed. The direction is
 * derived from the value rounded to cents, so an amount that displays as
 * $0.00 is never paired with a direction word.
 */
export function formatAmount(amount: number) {
  const rounded = Math.round(amount * 100) / 100

  const formatted = Math.abs(rounded).toLocaleString('en-US', {
    style: 'currency',
    currency: 'USD',
  })

  if (rounded === 0) {
    return formatted
  }

  return `${formatted} ${rounded > 0 ? 'refund' : 'owed'}`
}
